// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { initialize } from 'redux-form'
import initialContactLookupFormValues from 'components/SearchAndSelect/Sets/Contact/initialFormValues'

const clearContactValues = sourceForm => dispatch => {
  const initialValues = {
    ...initialContactLookupFormValues,
  }

  dispatch(initialize(sourceForm, initialValues))
}

export default clearContactValues
